import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { OPS_ITEMS, canSeeItem } from '../menuConfig';
import { getOpsAccount, opsNotifications, okCode } from '../api/ops';

// Màn "Vận hành" của thanh điều hướng mobile (thay tab KPI cho nhân sự Phòng OP): liệt kê các chức
// năng vận hành để bấm 1 phát là vào. Mở từ đây thì màn con có nút back quay lại chính màn này
// (App.jsx truyền onBack — xem setPage(key, 'ops')).
const TINT = '#00853c'; // màu nhóm VẬN HÀNH, khớp GROUP_META bên MobileMenuPage

// Số thông báo vận hành CHƯA ĐỌC, đếm y như màn Thông báo vận hành (gộp mọi tài khoản PMBox, !is_read).
// Chưa liên kết tài khoản thì KHÔNG gọi: proxy sẽ trả OPS_LOGIN và api/ops.js bắn 'ft:ops-login' vô ích.
// Lỗi mạng/hết phiên -> im lặng, không hiện số (không toast làm phiền ở màn danh sách).
// Mở màn con rồi quay lại thì màn này mount lại -> tự đếm lại, số giảm theo những tin vừa đọc.
function useOpsUnread(enabled) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    (async () => {
      try {
        const acc = await getOpsAccount();
        if (!acc?.linked) return;
        const d = await opsNotifications();
        const list = okCode(d) ? d.data?.results || [] : [];
        if (alive) setCount(list.filter((n) => !n.is_read).length);
      } catch { /* bỏ qua: chỉ là số đếm phụ */ }
    })();
    return () => { alive = false; };
  }, [enabled]);
  return count;
}

export default function MobileOpsPage({ setPage }) {
  const { me } = useAuth();
  const items = OPS_ITEMS.filter((i) => canSeeItem(me, i));
  const unread = useOpsUnread(items.some((i) => i.key === 'ops-notify'));

  return (
    <div className="page mbmenu">
      <div className="page-head">
        <div>
          <h2>Vận hành</h2>
          <div className="sub">Chọn chức năng kho / giao hàng</div>
        </div>
      </div>

      {items.length ? (
        <div className="mbmenu-sec">
          {items.map((i) => (
            <button key={i.key} type="button" className="mbmenu-row" onClick={() => setPage(i.key, 'ops')}>
              <span className="mbmenu-row-ico" style={{ color: TINT, background: `color-mix(in srgb, ${TINT} 12%, transparent)` }}>
                <i className={`ti ${i.ico}`} />
              </span>
              <span className="mbmenu-row-label">{i.label}</span>
              {i.key === 'ops-notify' && unread > 0 && (
                <span className="mbmenu-badge" aria-label={`${unread} thông báo chưa đọc`}>{unread > 99 ? '99+' : unread}</span>
              )}
              <i className="ti ti-chevron-right mbmenu-chev" />
            </button>
          ))}
        </div>
      ) : (
        <div className="empty">Tài khoản của bạn chưa có chức năng vận hành nào.</div>
      )}
    </div>
  );
}
